import Footer from "../../components/fragments/footer";
import Hero from "../../components/ui/hero";
import Hero2 from "../../components/ui/hero2";

function Beranda() {
  return (
    <div>
      <Hero />
      <Hero2 />
      <Footer />
    </div>
  );
}

export default Beranda;
